import { Module } from 'vuex';
import { RootState } from '@/plugins/store';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';
import { AccountState, state } from './state';

const AccountModule: Module<AccountState, RootState> = {
    state,
    mutations,
    actions,
    getters,
};

export default AccountModule;
export type {AccountState};
